import IGuid = System.IGuid;

export enum FieldsNdiStatsDataType {
  NIndex = 0,
  NUptake = 1
}

export interface IFieldsNdiStatsData {
  FieldId: IGuid;
  FieldName: string | undefined;
  AreaHa: number | undefined;
  Cells: number | undefined;
  NIndexAvg: number | undefined;
  NIndexMin: number | undefined;
  NIndexMax: number | undefined;
  NUptakeAvg: number | undefined;
  NUptakeMin: number | undefined;
  NUptakeMax: number | undefined;
  NIndexHistogram: { [key: string]: number } | undefined;
  NUptakeHistogram: { [key: string]: number } | undefined;
}

export type FieldsNdiStatsDropDownItem = {
  Id: FieldsNdiStatsDataType;
  Text: string;
};

export type DataPresence = {
  IsGenericBarsDataPresent: boolean,
  IsPlotBoxDataPresent: boolean
};
